VjsAdmin.AllLicenses = (function () {
    const $table = $('#licenses-table');
    let $dateRangeModal;
    const platformId = $table.attr('data-platform-id');
    const me = {};
    me.include_usage = 0;
    me.date_range_from = null;
    me.date_range_to = null;

    const queryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.active = null;
        myParams.expire_in_days = null;
        myParams.activated_in_days = null;
        myParams.include_usage = me.include_usage;
        myParams.date_range_from = me.date_range_from == null ? null : me.date_range_from.format();
        myParams.date_range_to = me.date_range_to == null ? null : me.date_range_to.format();

        switch (this.search_status) {
            case 'all':
                myParams.active = null;
                break;
            case 'active':
                myParams.active = 1;
                break;
            case 'expired':
                myParams.active = 0;
                break;
            case 'expire-30':
                myParams.active = 1;
                myParams.expire_in_days = 30;
                break;
            case 'expire-60':
                myParams.active = 1;
                myParams.expire_in_days = 60;
                break;
            case 'expire-90':
                myParams.active = 1;
                myParams.expire_in_days = 90;
                break;
            case 'activate-30':
                myParams.active = 1;
                myParams.activated_in_days = 30;
                break;
            case 'activate-60':
                myParams.active = 1;
                myParams.activated_in_days = 60;
                break;
            case 'activate-90':
                myParams.active = 1;
                myParams.activated_in_days = 90;
                break;
            case 'exceeding-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 1;
                break;
            case 'within-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 0;
                break;
            default:
                break;
        }
        return myParams;
    };

    const init = function () {
        $('#include-usage-stats').prop('checked', false);

        initTable();

        $('.app-content').on('click', '#export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = queryParams.call($table.bootstrapTable('getOptions'));
            const visibleColumns = $table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            if ($('#include-usage-stats').prop('checked')) {
                exportColumns.usage_date_range = 'Usage Date Range';
            }
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        // handle the Include Usage Stats button...
        $('.app-content').on('click', '#include-usage-toggle, #include-usage-stats', (e) => {
            e.preventDefault();
            if (+me.include_usage === 1) {
                $('#include-usage-stats').prop('checked', false);
                me.include_usage = 0;
                $table.bootstrapTable('refreshOptions', {
                    columns: +platformId === 1 ? vjsColumnsWithoutUsage : jrColumnsWithoutUsage,
                });
            } else {
                $dateRangeModal.modal({
                    backdrop: 'static',
                    keyboard: false,
                });
            }
            return false;
        });

        const dateRangeForm = $('<div>').html($('#date-range-form-template').html());

        const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

        $continueButton.on('click', (e) => {
            e.preventDefault();

            let errors = false;
            if ($('#date_range_from').val() === '') {
                $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#date_range_to').val() === '') {
                $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
            }

            if (errors) {
                return false;
            }

            // if we're here, we have good dates, lets refresh the table with include_usage set to ON
            me.include_usage = 1;

            if (
                typeof $('#date_range_from').val() !== 'undefined'
                && $('#date_range_from').val() !== null
                && $('#date_range_from').val() !== ''
            ) {
                $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                me.date_range_from = moment($('#date_range_from').val()).utc();
            }
            if (
                typeof $('#date_range_to').val() !== 'undefined'
                && $('#date_range_to').val() !== null
                && $('#date_range_to').val() !== ''
            ) {
                $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                me.date_range_to = moment($('#date_range_to').val()).utc();
            }

            // refresh the table, with the usage columns shown...
            let columns;
            switch (platformId) {
                case '1':
                    columns = { columns: vjsColumnsWithUsage };
                    break;
                case '4':
                    columns = { columns: cpColumnsWithUsage };
                    break;
                default:
                    columns = { columns: jrColumnsWithUsage };
                    break;
            }
            $table.bootstrapTable('refreshOptions', columns);

            // set the checkbox to 'checked'
            $('#include-usage-stats').prop('checked', true);

            $dateRangeModal.modal('hide');

            return true;
        });

        $dateRangeModal = VjsAdmin.Modal.create({
            id: 'include-usage-modal',
            title: 'Choose Date Range for Usage Stats',
            body: dateRangeForm,
            footer: $continueButton,
            onShown() {
                VjsAdmin.initDateRangePickers($('#include-usage-modal'));
            },
        });

        $table.on('click', 'th.date-range-header', () => {
            $dateRangeModal.modal({ backdrop: 'static', keyboard: false });
        });
    };

    const initTable = function () {
        $table.addClass('loading');

        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#licenses-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                const activeStatus = this.search_status;
                let type = '';
                switch (activeStatus) {
                    case 'all':
                        type = 'licenses';
                        break;
                    case 'active':
                        type = '<strong>active</strong> licenses';
                        break;
                    case 'expired':
                        type = '<strong>expired</strong> licenses';
                        break;
                    default:
                        type = `licenses <strong>${$('#search-status option:selected').text()}</strong>`;
                        break;
                }
                return `No ${type}${
                    typeof searchTerm !== 'undefined' && searchTerm !== '' ? ` matching search term \`${SafeDOM.escapeHtml(searchTerm)}\`` : ''
                } in this district.`;
            },
            idField: 'license_id',
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: 'date_created',
            sortOrder: 'desc',
            search_status: 'active',
            showColumns: true,
            url: Slim.Router.pathFor('platforms.licenses.all.json', {
                platform_id: platformId,
            }),
            queryParams,
            columns: +platformId === 1 ? vjsColumnsWithoutUsage : jrColumnsWithoutUsage,
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);
                    const diffHours = moment().diff(moment(row.date_created).utc(), 'hours');

                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.disable_links === 0) {
                        row.disable_links = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else if (+row.disable_links === 1) {
                        row.disable_links = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.license_searchable === 0) {
                        row.license_searchable = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else if (+row.license_searchable === 1) {
                        row.license_searchable = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.time_spent = VjsAdmin.secondsToHoursMinutes(row.time_spent);

                    if (row.user_count > row.user_account_limit) {
                        row.user_account_limit += '<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>';
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.list')) {
                        const licensesUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.district_name = `<a href="${licensesUrl}">${row.district_name}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                        const statsUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.license_name = `<a href="${statsUrl}">${row.license_name}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.users.list')) {
                        const usersUrl = Slim.Router.pathFor('platforms.districts.licenses.users.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.user_count = `<a href="${usersUrl}?search_roles=users">${row.user_count}</a>`;
                        row.admin_count = `<a href="${usersUrl}?search_roles=admins">${row.admin_count}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.groups.list')) {
                        const groupsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.group_count = `<a href="${groupsUrl}">${row.group_count}</a>`;
                    }

                    row.actions = '';
                    if (VjsAdmin.hasPermission('platforms.districts.licenses.edit.view')) {
                        const editLicenseUrl = Slim.Router.pathFor('platforms.districts.licenses.edit.view', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.actions += `<a href="${editLicenseUrl}" class="">Edit</a>`;
                    }

                    if (diffHours < 24) {
                        row.license_name += ' <span class="badge badge-pill badge-success new-badge">NEW</span>';
                    }
                });
                return formattedResult;
            },
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;
                $('#search-status').off();
                $('#search-status').on('change', () => {
                    thisTable.search_status = $('#search-status option:selected').val();
                    thisTable.updateUrl();
                    $('#users-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_status === 'undefined') {
                    this.default_search_status = this.search_status;
                }
                this.search_status = $.urlParam('search_status') != null ? $.urlParam('search_status') : this.default_search_status;
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                if (
                    typeof me.date_range_from !== 'undefined'
                    && me.date_range_from != null
                    && typeof me.date_range_to !== 'undefined'
                    && me.date_range_to != null
                ) {
                    $table
                        .find('th.date-range-header')
                        .html(
                            `<a href="#"><i class="fa fa-calendar" aria-hidden="true"></i> ${me.date_range_from.format(
                                'l',
                            )} to  <i class="fa fa-calendar" aria-hidden="true"></i> ${me.date_range_to.format('l')}</a>`,
                        );
                } else if (typeof me.date_range_from !== 'undefined' && me.date_range_from !== null) {
                    $table
                        .find('th.date-range-header')
                        .html(`<a href="#"><i class="fa fa-calendar" aria-hidden="true"></i> ${me.date_range_from.format('l')} to Now</a>`);
                }
                if (this.search_status !== this.default_search_status) {
                    $('#search-status').val(this.search_status);
                    $(`#search-status > option:eq(${this.search_status})`).prop('selected', true);
                }
            },
            updateUrl() {
                const params = {};
                if (this.search_status !== this.default_search_status) {
                    params.search_status = this.search_status;
                }

                VjsTable.tableDefaults().updateUrl.call(this, params);
            },
            onColumnSwitch() {
                $table.bootstrapTable('refresh');
            },
        });
    };

    const vjsColumnsWithoutUsage = [
        {
            title: 'District',
            field: 'district_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Name',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Disable Links?',
            field: 'disable_links',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Searchable?',
            field: 'license_searchable',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    const vjsColumnsWithUsage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'QA Videos<br>Watched',
                field: 'videos_watched_qa',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Career<br>Journals',
                field: 'career_journals',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Résumés<br>Completed',
                field: 'resumes_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Quizzes<br>Completed',
                field: 'quiz_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Disable Links?',
                field: 'disable_links',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Searchable?',
                field: 'license_searchable',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    const cpColumnsWithUsage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Disable Links?',
                field: 'disable_links',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Searchable?',
                field: 'license_searchable',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    const jrColumnsWithoutUsage = [
        {
            title: 'District',
            field: 'district_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'License',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    const jrColumnsWithUsage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Cluster<br>Videos<br>Watched',
                field: 'videos_watched_cluster',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'Career<br>Videos<br>Watched',
                field: 'videos_watched_career',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'QA<br>Videos<br>Watched',
                field: 'videos_watched_career_qa',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Lessons<br>Completed',
                field: 'lessons_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 5,
                class: 'date-range-header',
            },
        ],
    ];

    return {
        init,
    };
}());
